<template>
  <div>
    <v-layout align-content-space-between align-center row class="my-2">
      <v-flex shrink class="mr-2">
        <v-img v-if="employee.profile_picture_url" height=200 width=200 contain
          :src="employee.profile_picture_url"
        >
        </v-img>
      </v-flex>
      <v-flex grow>
        <h2>
          <EmployeeName :employee="employee" />
        </h2>
        <h2 class="subtle">
          Position{{ employee.position_names.length > 1 ? "s" : "" }}:
          <div class="inline-list">
            <span v-for="position in employee.position_names">{{ position }}</span>
          </div>
        </h2>
        <h2 class="subtle">Status: {{ employee.status }}</h2>
      </v-flex>
      <v-spacer grow>
      </v-spacer>
      <v-flex shrink class="text-xs-right">
        <v-layout column>
          <v-flex>
            <v-dialog v-model="removalDialog" full-width max-width="400">
              <v-btn slot='activator' block color='error'>
                <v-icon
                  left
                > remove_circle </v-icon>
                  Request Removal
              </v-btn>
              <v-card>
                <v-card-text class="text-sx-center">
                  <h2 class="headline">Request employee removal?</h2>
                  <p>This will send a message to your manager requesting that
                  this employee be removed from your team.</p>

                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="grey" flat @click="removalDialog = false">Nevermind</v-btn>
                  <v-btn color='error' small @click="requestRemoval">
                    Yes, send request
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-layout row>
      <!-- large bar -->
      <v-toolbar color="primary" flat dense class="hidden-sm-and-down"  style="overflow-x: auto;">
        <v-toolbar-items v-for="item in tabOptions" :key="`${ item.routeName }-1`">
          <v-btn small flat color="white" :to="{ name: item.routeName }" exact>
            {{ item.linkLabel }}
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
    </v-layout>

    <v-layout row>
      <component
        :is="componentName"
        v-bind="{ employee, user }"
      ></component>
    </v-layout>

  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Info from '@/components/hr/client-view-employee-info.vue'
import WorkHistory from '@/components/hr/client-view-work-history.vue'
import Contact from '@/components/hr/employee-contact.vue'
import EmployeeName from '@/components/hr/employee-name.vue'
import HeaderBar from '@/components/base/header-bar.vue'

export default {
  components: {
    Info,
    WorkHistory,
    Contact,
    EmployeeName,
    HeaderBar
  },
  created () {
    this.$store.dispatch('employees/getPrimaryPositionsForDetailedEmployee', this.$route.params.employeeId)
  },
  computed: {
    ...mapState('employees', [
      'detailedEmployee'
    ]),
    ...mapState('userAuth', [
      'user'
    ]),
    employee () {
      return this.detailedEmployee
    },
    componentName() {
      const currentComponent = this.tabOptions.find((o) => {
        return o.routeName === this.$router.currentRoute.name
      })

      if (!currentComponent) {
        this.$router.push({ name: 'employee/info' })
        return 'Info'
      }

      return currentComponent.componentName
    },
  },
  methods: {
    requestRemoval () {
      this.$store.dispatch('messages/sendToManager',
        {
          subject: "Employee team removal request",
          message: `Hello,\n\n${ this.user.displayName } requests that you remove ${ this.employee.displayName } from their team.`
        }
      ).then(res => {
        this.$store.dispatch('global/showSnackbarSuccess', { message: 'Request sent!' })
      })
      .catch(res => {
        this.$store.dispatch('global/showSnackbarError', { message: 'Something went wrong with that message' })
      })
      .finally(res => {
        this.removalDialog = false
      })
    },
  },
  data: function() {
    return {
      removalDialog: false,
      tabOptions: [
        {
          routeName: "employee/info",
          linkLabel: "Info",
          componentName: 'Info',
        },
        {
          routeName: "employee/work-history",
          linkLabel: "Work History",
          componentName: 'WorkHistory',
        },
        {
          routeName: "employee/contact",
          linkLabel: "Contact",
          componentName: 'Contact',
        },
      ],
    }
  },
}
</script>

<style scoped>
#dashboard-container {
}
</style>
